import { trpc } from "@utils/trpc";
import type { LiveRoom } from "@libs/types/access-live";
import { useLiveRoomRealtime } from "./useLiveRoomRealtime";

export const useLiveRoom = (accessId: string | null | undefined) => {
  const enabled = !!accessId;
  const queryAccessId = accessId ?? "";

  useLiveRoomRealtime(queryAccessId, enabled);

  const liveRoomQuery = trpc.user.liveRoom.get.useQuery(
    { accessId: queryAccessId },
    {
      enabled,
    },
  );

  const liveRoomData = (liveRoomQuery.data ?? null) as LiveRoom | null;
  const isLive = liveRoomData !== null && liveRoomData.is_live === true;
  const hasActivities =
    liveRoomData?.activities && liveRoomData.activities.length > 0;

  return {
    liveRoomData,
    isLive,
    hasActivities,
    isLoading: enabled && liveRoomQuery.isLoading,
  };
};
